(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-factory-announcement-slider"] && !Shopify.designMode) return;
  try {
    
  /**
   * Rotating announcement bar. Each instance cross-fades through its
   * `__item` messages; prev/next arrows step manually and autoplay (when
   * enabled, and only with >1 message) advances on an interval. Hovering
   * the bar pauses autoplay. Re-initialised on `shopify:section:load` so
   * the theme editor reflects edits live.
   */
  (function () {
    function init(bar) {
      // Idempotency guard. `initAll` re-scans the whole document on every
      // `shopify:section:load`, so editing ANY sibling section in the Theme
      // Editor would otherwise re-init untouched bars — stacking listeners
      // and starting a second setInterval whose predecessor is unreachable
      // (captured in a prior closure). A replaced section is a fresh node
      // with no flag, so live edits to THIS section still re-init correctly.
      if (bar.dataset.pa1Initialized === 'true') return;
      bar.dataset.pa1Initialized = 'true';

      var items = bar.querySelectorAll('.product-announcement-1__item');
      if (!items.length) return;
      var n = items.length;
      var idx = 0;
      var timer = null;
      var autoplay = bar.dataset.autoplay === 'true';
      var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      var prev = bar.querySelector('.product-announcement-1__arrow--prev');
      var next = bar.querySelector('.product-announcement-1__arrow--next');

      function show(i) {
        idx = (i + n) % n;
        for (var k = 0; k < n; k++) {
          items[k].classList.toggle('is-active', k === idx);
        }
      }
      function restart() {
        if (timer) clearInterval(timer);
        if (autoplay && n > 1) timer = setInterval(function () { show(idx + 1); }, speed);
      }
      function go(delta) { show(idx + delta); restart(); }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      bar.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      bar.addEventListener('mouseleave', restart);

      show(0);
      restart();
    }
    function initAll() {
      document.querySelectorAll('[data-pa1-slider]').forEach(init);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-factory-before-after-slider"] && !Shopify.designMode) return;
  try {
    
  /**
   * Drag-to-compare slider behaviour. Self-contained per section —
   * pulls the `--pba1-compare` CSS variable from the range input's
   * value on every input event. CSS handles the rest: clip-path on
   * the after layer, handle/divider position. Multiple instances
   * on a single page are handled by the data-attribute query.
   */
  (function () {
    document.querySelectorAll('[data-pba1-slider]').forEach(function (slider) {
      var range = slider.querySelector('[data-pba1-range]');
      if (!range) return;
      var sync = function () {
        slider.style.setProperty('--pba1-compare', range.value);
      };
      range.addEventListener('input', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-factory-hero-1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(gallery) {
      if (gallery.dataset.pfGalleryReady) return;
      gallery.dataset.pfGalleryReady = '1';
      var slides = gallery.querySelectorAll('[data-pf-slide]');
      var thumbs = gallery.querySelectorAll('[data-pf-thumb]');
      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-pf-thumb]');
        if (!thumb || !gallery.contains(thumb)) return;
        var index = thumb.getAttribute('data-pf-thumb');
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-pf-slide') === index);
        });
        thumbs.forEach(function (button) {
          var isActive = button === thumb;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      });
    }
    function initAll() {
      document.querySelectorAll('[data-pf-gallery]').forEach(initGallery);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-factory-review-cards"] && !Shopify.designMode) return;
  try {
    
  /**
   * Review-cards "Ver más" toggle. Each review's text is CSS line-clamped to
   * a fixed number of lines so a long review can't stretch its card past the
   * others. This reveals the per-card toggle ONLY when the clamp actually
   * hides content (scrollHeight > clientHeight on the clamped box), and
   * expands / collapses on click. Re-measures on resize (line count changes
   * with column width) and re-inits on shopify:section:load so the theme
   * editor reflects edits live.
   */
  (function () {
    function measure(block) {
      var text = block.querySelector('.product-review-cards-1__text');
      var btn = block.querySelector('.product-review-cards-1__more');
      if (!text || !btn || text.classList.contains('is-expanded')) return;
      btn.hidden = text.scrollHeight - text.clientHeight <= 2;
    }
    function setup(section) {
      section.querySelectorAll('.product-review-cards-1__text-block').forEach(function (block) {
        var text = block.querySelector('.product-review-cards-1__text');
        var btn = block.querySelector('.product-review-cards-1__more');
        if (!text || !btn) return;
        if (!btn.dataset.bound) {
          btn.dataset.bound = '1';
          btn.addEventListener('click', function () {
            var open = text.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            btn.textContent = open
              ? (btn.dataset.less || 'Ver menos')
              : (btn.dataset.more || 'Ver más');
            // Collapsing re-applies the clamp: re-measure so the toggle hides
            // if the text now fits (e.g. the viewport widened while expanded,
            // which `measure` skipped because the clamp was off). `measure`
            // no-ops while expanded, so this only matters on collapse.
            if (!open) measure(block);
          });
        }
        measure(block);
      });
    }
    function initAll() {
      document.querySelectorAll('.product-review-cards-1').forEach(setup);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    var raf;
    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        document.querySelectorAll('.product-review-cards-1__text-block').forEach(measure);
      });
    });
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target && e.target.querySelector
        ? e.target.querySelector('.product-review-cards-1')
        : null;
      if (section) setup(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
